import React from 'react';
import { observer } from 'mobx-react-lite';
import { Table, TableBody, TableHeader, TableHeading, TableRow } from '@insurancemenu/imenu-components-lib';
import { useRootStore } from 'store/rootStore';
import clsx from 'clsx';
import { createScrollEffectStyles } from 'components/common/styles/verticalScrollEffect';
import { GroupProposalPerPeriod } from 'store/ui-stores/group-info/groupProposalsTableStore';
import { createStyles } from './styles';
import QuoteTableRow from './ProposalsTableRow';

interface QuotesTableProps {
  groupProposals: GroupProposalPerPeriod[];
}

const QuotesTable = observer(({ groupProposals }: QuotesTableProps): JSX.Element => {
  const classes = createStyles();
  const scrollEffectClasses = createScrollEffectStyles();

  // Mobx store
  const {
    groupProposalsTableStore: { loading },
    enrollmentCardStore: { loading: enrollLoading },
  } = useRootStore();

  const QuoteRows = (): JSX.Element[] => {
    return groupProposals.map((groupProposalPerPeriod) => (
      <QuoteTableRow
        proposal={groupProposalPerPeriod.proposal}
        enrollmentPeriod={groupProposalPerPeriod.enrollmentPeriod}
        key={groupProposalPerPeriod.proposal.name}
      />
    ));
  };

  return (
    <div className={classes.tableWrapper}>
      <Table loading={loading || enrollLoading} totalElements={groupProposals.length}>
        <TableHeader className={classes.tableHeader}>
          <TableRow>
            <TableHeading className={classes.tableHeading}>Quote</TableHeading>
            <TableHeading className={classes.tableHeading}>Effective Date</TableHeading>
            <TableHeading className={classes.tableHeading}>Product Lines</TableHeading>
            <TableHeading className={classes.tableHeading} />
          </TableRow>
        </TableHeader>
        <TableBody className={clsx(classes.tableBody, scrollEffectClasses.scrollEffect)}>{QuoteRows()}</TableBody>
      </Table>
    </div>
  );
});

export default QuotesTable;
